export enum SimpleV2AssignmentType {
  Happy = 'happy',
  Abandonment = 'abandonment',
  Exception = 'exception',
}

export enum SimpleV2LeadType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum SimpleV2AssignmentStep {
  PricingShown = 'pricing-shown',
  PricingFailed = 'pricing-failed',
  PlaidOptOut = 'plaid-opt-out',
  VoaAssetReportDataFailure = 'voa-asset-report-data-failure',
  CreditPullFailed = 'credit-pull-failed',
  AusIneligible = 'aus-ineligible',
}

export interface SimpleV2AssignmentContext {
  stage: string | null
  lastCompletedStep: string
  assignmentType: SimpleV2AssignmentType
  leadType: SimpleV2LeadType
  assignedAt?: string
}
